var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "booking-calendar" },
    [
      _c("div", { staticClass: "is-flex", staticStyle: { height: "94%" } }, [
        _c(
          "div",
          {
            staticClass:
              "calendar-container thin-scollbar animate__animated animate__fadeIn",
            class: [
              {
                "is-full-width": !_vm.isSidePanelOpen,
                loading: !!_vm.isLoading,
              },
            ],
          },
          [
            _c("calendar", {
              ref: "calendar",
              attrs: {
                "calendar-options": _vm.innerCalendarOptions,
                "business-hours": [],
                events: _vm.innerEvents,
                "is-show-weekend": _vm.isShowWeekend,
                "override-business-hours": _vm.overrideBusinessHours,
                "event-type": _vm.selectedEventType,
              },
              on: {
                "fetch-data": _vm.handleFetchData,
                "event-click": _vm.handleEventClick,
                "date-select": _vm.handleDateSelect,
                drop: _vm.handleDrop,
                "event-resize": _vm.handleEventResize,
                "event-drop": _vm.handleEventDrop,
                "event-receive": _vm.handleEventReceive,
                "event-type-changed": _vm.handleEventTypeChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ eventInfo }) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "custom-event",
                          class: { "has-text-black": !_vm.isQuote(eventInfo) },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi pl-1",
                            class: _vm.renderIcon(eventInfo),
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.renderTimeText(eventInfo)) +
                              "; " +
                              _vm._s(eventInfo.event.title) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "aside",
        {
          staticClass: "booking-panel",
          class: { closed: !_vm.isSidePanelOpen, open: _vm.isSidePanelOpen },
        },
        [
          _c("booking-calendar-side-panel", {
            ref: "bookingCalendarSidePanel",
            attrs: {
              "is-side-panel-open": _vm.isSidePanelOpen,
              "is-show-detail": _vm.isShowDetail,
              "booking-id": _vm.selectedBookingId,
            },
            on: {
              handleSidePanelToggle: _vm.handleSidePanelToggle,
              toggleWeekend: _vm.handleToggleWeekend,
              handleBookingDateChange: _vm.handleBookingDateChange,
              handleQuoteDateChange: _vm.handleQuoteDateChange,
            },
          }),
        ],
        1
      ),
      _c("booking-simple-view-modal", {
        attrs: {
          active: _vm.isSimpleBookingModelActive,
          "booking-id": _vm.selectedEditBookingId,
          visible: _vm.isSimpleBookingModelActive,
          "is-new": _vm.isNewSimpleBooking,
          "booking-start-date": _vm.selectedBookingStartDate,
        },
        on: {
          "update:active": function ($event) {
            _vm.isSimpleBookingModelActive = $event
          },
          close: _vm.handleSimpleBookingModalClosed,
          save: _vm.handleSimpleBookingSave,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }